<div class="flex">
  <sbnb-subnav [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-transaction-add'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main class="flex flex-1 subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="w-full">
      <app-feature-flag-tabs class="w-full">
        <sbnb-page-header navTabs>
          <section class="flex items-center gap-1 justify-center sbnbDesktop:justify-start">
            <sbnb-back-button label=" "></sbnb-back-button>
            <h2 class="flex-1 !mb-0 text-center sbnbDesktop:text-left">Add a transaction</h2>
          </section>
        </sbnb-page-header>
        <section class="flex items-center gap-1">
          <sbnb-back-button label=" "></sbnb-back-button>
          <h2 class="flex-1 !mb-0">Add a transaction</h2>
        </section>
      </app-feature-flag-tabs>
      <sbnb-transaction-form (saveSuccess)="onSave()"></sbnb-transaction-form>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
